import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';

import CoachingToDo from '../../../../components/CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../../../../components/coachingShoutOut/coachingShoutOUt';
import { CoreValueDropdown } from '../../../../components/coreValueDropdown/CoreValueDropdown';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import { UpdateCoachingStrength, usePutCoachingUpdateCoachingStrengthMutation } from '../strengthSlice';
import { validateFormStrength } from '../strengths-service';
import '../strengths.scss';
import { StrengthList } from '../types';
// import { SkillBehaviorDropdown } from '../../../../components/skillBehaviorDropdown/SkillBehaviorDropdown';
// import { selectIsUseCoachingSkills } from '../../../../pages/login/authSlice';

export type StrengthProps = {
    OnViewState: (viewState: 'read' | 'edit' | 'new') => void;
    OnDisplayModal: (displayModal: boolean) => void;
    displayModal: boolean;
    authorName: string;
    recieverId: string;
    isRecipient?: boolean;
    strength?: StrengthList;
    receiverName: string;
    month?: number;
    year?: number;
};

const UpdateStrength = ({
    OnViewState,
    OnDisplayModal,
    displayModal,
    authorName,
    recieverId,
    strength,
    receiverName,
    month,
    year,
}: Readonly<StrengthProps>) => {
    const [UpdateStrength] = usePutCoachingUpdateCoachingStrengthMutation();
    const [todoVisible, setTodoVisible] = useState(false);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [title, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [coreValue, setCoreValue] = useState(0);
    const [coachingStrength, setStrength] = useState(0);
    const [date, setDate] = useState(new Date());
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    // const [skill, setSkill] = useState<number>(0);
    // const [behavior, setBehavior] = useState<number>(0);
    // const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);

    useEffect(() => {
        if (strength) {
            setSubject(strength.strength_title);
            setDescription(strength.strength_description);
            setCoreValue(strength.core_value_id);
            setStrength(strength.coaching_strength_id);
            setDate(new Date(strength?.strength_date));
            setMonth(month ?? 0);
            setYear(year ?? 0);
            // setSkill(strength.coaching_skill_id);
            // setBehavior(strength.coaching_behavior_id);
        }
    }, [strength]);

    const setViewState = (viewState: 'read' | 'edit' | 'new') => {
        OnViewState(viewState);
    };

    const handleCancel = () => {
        setViewState('read');
    };

    const DateOnChange = (e: any) => {
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
    };

    const handleSave = () => {
        if (
            !validateFormStrength(
                title,
                coreValue,
                description //, skill, behavior, isUseCoachingSkills
            )
        )
            return;
        const request: UpdateCoachingStrength = {
            coachingStrengthId: coachingStrength,
            coreValueId: coreValue,
            strengthTitle: title,
            strengthDescription: description,
            month: inputMonth,
            year: inputYear,
            // coachingBehaviorId: behavior,
            // coachingSkillId: skill,
        };

        UpdateStrength({ updateCoachingStrength: request })
        .unwrap()
        .then((res: any) => {
            if (res?.data) setViewState('read');
            else toast.error('Something went wrong');
        })
        .catch((error: any) => {
            debugger;
            toast.error(error);
        });
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };
    const renderHeader = () => {
        return (
            <div>
                <h3>Strengths</h3>
            </div>
        );
    };

    return (
        <Dialog
            header={renderHeader()}
            visible={displayModal}
            onHide={() => {
                OnDisplayModal(false);
                OnViewState('read');
            }}
            className="card shadow bg-body rounded mt-4 border-0 p-4 w-80"
            modal
            draggable={false}
            resizable={false}
            style={{
                width: '73vw',
                height: '90vh',
            }}
            position="top-right"
        >
            <div className="flexHeader mt-3">
                <h5 className="mb-2">Edit Strength</h5>
            </div>

            <div className="logConversation-coaching mt-4 mb-4">
                <div className="flex-coaching mb-3">
                    <div className="col-4 me-2">
                        <h6>Title</h6>
                        <div>
                            <InputText
                                placeholder="Title"
                                className="w-100 borderRadius8"
                                value={title}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="me-2">
                        <h6>Month</h6>
                        <div>
                            <Calendar
                                id="selectmonth"
                                view="month"
                                value={date}
                                onChange={DateOnChange}
                                maxDate={new Date()}
                                showIcon
                                className="custom-calendar"
                                dateFormat="MM, yy"
                                // style={{ width: '20rem' }}
                            />
                        </div>
                    </div>

                    <div className="col-4">
                        <CoreValueDropdown fullWidth coreValue={coreValue} setCoreValue={setCoreValue} />
                    </div>
                </div>

                {/* {!isUseCoachingSkills ? (
                        <div className="col-4 me-2">
                            <CoreValueDropdown fullWidth coreValue={coreValue} setCoreValue={setCoreValue} />
                        </div>
                    ) : (
                        ''
                    )}
                </div>

                {isUseCoachingSkills ? (
                    <SkillBehaviorDropdown
                        fullWidth
                        skill={skill}
                        setSkill={setSkill}
                        behavior={behavior}
                        setBehavior={setBehavior}
                    />
                ) : (
                    ''
                )} */}

                <div>
                    <DescriptionBox
                        createdByLabel="Author"
                        createdByValue={authorName}
                        title={'Description'}
                        limit={4000}
                        onChange={handleDescriptionChange}
                        value={description || ''}
                    />
                </div>
                <div className="flexButtons mt-3">
                    <div>
                        <Button
                            label="Cancel"
                            onClick={handleCancel}
                            className="btn-secondary me-2"
                        />
                        <Button label="Save" onClick={handleSave} className="btn-primary me-2" />
                    </div>
                </div>
            </div>

            <div className="flexButtons mb-4">
                <CoachingToDo
                    receiverId={recieverId}
                    receiverName={receiverName}
                    visible={todoVisible}
                    setVisible={setTodoVisible}
                    coachingEntityId={coachingStrength}
                    coachingEntityTypeId={3}
                    coachingStatusId={1}
                />
                <CoachingShoutOut
                    receiverId={recieverId}
                    receiverName={receiverName}
                    visible={shoutoutVisible}
                    setVisible={setShoutoutVisible}
                    coachingEntityId={coachingStrength}
                    coachingEntityTypeId={3}
                    coreValueId={coreValue}
                />
            </div>
        </Dialog>
    );
};
export default UpdateStrength;
